module.exports = __webpack_public_path__ + "static/img/aviso_TDE.7c99b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aviso_TDE.png
// module id = knyF
// module chunks = 9